'use client'

import { useQuery } from '@tanstack/react-query'
import { useApiFetch } from '@/features/auth'
import { fetchMarketTicker } from '@/features/market-data/api/market-data.api'
import { queryKeys } from '@/lib/queryKeys'

/** One of two narrowly-scoped exceptions to this app's "no polling" convention (the other is
 * `useCallStatus`, `use-case-detail.ts`) — justified here because this is polled, slowly-changing,
 * non-sensitive decorative data (the investor dashboard's market ticker, which drives zero
 * decisions anywhere in the app), not because the data is urgent. */
const REFETCH_INTERVAL_MS = 45_000

export function useMarketTicker() {
  const authedFetch = useApiFetch()
  return useQuery({
    queryKey: queryKeys.marketData.ticker,
    queryFn: () => fetchMarketTicker(authedFetch),
    refetchInterval: REFETCH_INTERVAL_MS,
    staleTime: 30_000,
  })
}
